import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";
import { CheckRow } from "./Section1";

export const Payment = ({
  refs,
}: {
  refs: {
    payment: React.RefObject<HTMLDivElement>;
    payService: React.RefObject<HTMLDivElement>;
    settle: React.RefObject<HTMLDivElement>;
    merchant: React.RefObject<HTMLDivElement>;
    sales: React.RefObject<HTMLDivElement>;
  };
}) => {
  const isMobile = useResponsiveMobile(900);
  return (
    <div
      id="settlement-history"
      className="flex flex-col gap-[80px] md:gap-20 overflow-y-hidden overflow-x-hidden"
      ref={refs.payment}
    >
      <div className="flex flex-col gap-[80px] md:gap-[56px] ">
        {/* 결제/정산 내역 소개글 */}
        <div className="flex flex-col gap-[32px] md:gap-10">
          <div className="flex flex-col gap-3">
            <h1 className="font-bold md:text-display text-[36px] flex items-center gap-[4px]">
              {isMobile && (
                <img
                  width="48"
                  height="48"
                  alt="결제/정산 내역"
                  src="/assets/images/icon/sidenav_list.png"
                />
              )}
              결제/정산 내역
            </h1>
            <span className="text-[18px] md:text-[20px] font-semibold text-[#0079FF]">
              결제와 정산, 하나의 흐름으로 연결합니다.
            </span>
          </div>

          {isMobile ? (
            <span className="text-[#4D4F58] text-[16px] leading-relaxed">
              품(Poom)은 복잡하게 분리된 거래 및 정산 데이터를 하나의 시스템으로 통합해 기업이 보다
              효율적으로 결제와 정산을 관리할 수 있도록 지원합니다. <br />
              <br />
              PG사, VAN사 등 거래 데이터를 표준화하여 한눈에 조회할 수 있으며, 수수료 계산과 정산
              내역도 자동화되어 보다 정확하고 신속한 업무 처리가 가능합니다.
            </span>
          ) : (
            <span className="text-[18px] text-[#4D4F58] leading-relaxed">
              품(Poom)은 복잡하게 분리된 거래 및 정산 데이터를 하나의 시스템으로 통합해 기업이 보다
              효율적으로 결제와 정산을 관리할 수 있도록 지원합니다.
              <br />
              PG사, VAN사 등 거래 데이터를 표준화하여 한눈에 조회할 수 있으며, 수수료 계산과 정산
              내역도 자동화되어 보다 정확하고 신속한 업무 처리가 가능합니다.
            </span>
          )}
        </div>

        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-3">
            <div className="flex flex-row gap-3 items-center">
              <img width={24} height={24} src="/assets/images/icon/search.png" alt="search" />
              <h2 className="font-normal text-[20px] md:text-[28px] ">결제부터 정산까지의 흐름</h2>
            </div>
            <span className="font-normal text-[16px] md:text-[18px]">
              품 결제 흐름에 대해 자세히 알려드려요
            </span>
          </div>

          {/* 결제/정산 흐름 이미지 */}
          <div className="w-full max-w-full overflow-hidden min-w-0 relative">
            {isMobile && (
              <div className="pointer-events-none absolute top-3 right-10 flex justify-center z-10 bg-black/50 px-3 py-1 rounded-full w-[fit-content]">
                <span className="text-[16px] text-white">↔ 좌우로 넘겨보세요</span>
              </div>
            )}
            <div className="w-full overflow-x-auto overflow-y-hidden overscroll-x-contain md:overflow-x-hidden">
              <div className="w-[1246px] md:w-full">
                <img
                  src={"/assets/images/introduction/eg1.png"}
                  alt="eg1"
                  className="block w-full h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 카드 섹션 영역 */}
      <div className="flex flex-col md:flex-col lg:flex-row gap-6 md:gap-[60px] xl:px-0">
        <div className="flex flex-col gap-3 md:gap-6 ">
          <span className="text-[#121319] font-bold text-[18px] md:text-display2">
            복잡한 결제의 흐름이 {isMobile ? "" : <br />} 하나의 안정된 리듬으로
          </span>
          <span className="font-normal text-[#4D4F58] text-[16px] md:text-heading1">
            분산된 거래 데이터를 {isMobile ? "" : <br />} 표준화하여 조회할 수 있어요
          </span>
        </div>

        <div className="flex flex-col min-[1200px]:flex-row flex-1 md:gap-[32px] gap-[12px]">
          {/* 카드 1 */}
          <div
            className="flex-1 flex flex-col rounded-[24px] md:min-h-[524px] min-[1200px]:mb-[160px]"
            style={{
              //  회색 보더(기본 유지)
              boxShadow: "inset 0 0 0 1px #DDE0E6",

              //  그라데이션을 border 영역에만 얹기 위한 세팅
              border: "3px solid transparent",
              backgroundOrigin: "border-box",
              backgroundClip: "padding-box, border-box",

              //  안쪽은 흰색, 바깥(border)은 부분 conic 그라데이션
              backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 270deg,
            #0079FF 60deg,
            #00FF44 100deg,
            #FFC300 110deg,
            transparent 90deg,
            transparent 360deg
          )
        `,
            }}
          >
            <div className="flex flex-col justify-start px-[24px] py-[32px] md:px-[40px] md:py-[100px] h-full">
              <div className="flex flex-col md:gap-6 gap-[24px]">
                <img
                  src="/assets/images/introduction/icon1.png"
                  alt="icon1"
                  width={56}
                  height={56}
                />

                <div className="flex flex-col md:gap-5 gap-3">
                  <span className="font-bold text-[18px] md:text-display3_1">
                    통합 거래내역 조회
                  </span>

                  <div className="flex flex-col gap-2">
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                          거래내역 실시간 확인
                        </span>
                      }
                    />
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                          PG사 및 VAN사 거래 데이터 표준화하여 관리 효율 향상
                        </span>
                      }
                    />
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                          결제취소/부분취소 가능
                        </span>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 카드 2 */}
          <div
            className="flex-1 flex flex-col rounded-[24px] min-[1200px]:mt-[160px]"
            style={{
              boxShadow: "inset 0 0 0 1px #DDE0E6",
              border: "3px solid transparent",
              backgroundOrigin: "border-box",
              backgroundClip: "padding-box, border-box",
              backgroundImage: `
          linear-gradient(#ffffff, #ffffff),
          conic-gradient(
            from 90deg,
            #0079FF 55deg,
            #00FF44 65deg,
            #FFC300 110deg,
            transparent 90deg,
            transparent 360deg
          )
        `,
            }}
          >
            <div className="flex flex-col justify-start md:px-[40px] md:py-[100px] px-[24px] py-[32px] h-full">
              <div className="flex flex-col md:gap-6 gap-[24px]">
                <img
                  src="/assets/images/introduction/icon2.png"
                  alt="icon2"
                  width={56}
                  height={56}
                />

                <div className="flex flex-col gap-5">
                  <span className="font-bold text-[18px] md:text-display3_1">
                    통합 정산내역 조회
                  </span>

                  <div className="flex flex-col gap-2">
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                          결제 후 발생한 수수료 자동계산
                        </span>
                      }
                    />
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                          거래내역과 정산내역을 자동으로
                          <br />
                          비교하여 오류 방지 (거래대사 자동화)
                        </span>
                      }
                    />
                    <CheckRow
                      content={
                        <span className="font-normal text-[16px] md:text-[18px] text-[#4D4F58]">
                          정산보고서 제공
                        </span>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
